import Login from '../../features/auth/login'

export const LoginPage = () => {
    return (
        <div>
            <Login />
        </div>
    )
}
